// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, DatePicker, Tree } from "antd";

//import styles
import "../partners.scss"

// Import components
import PageWrapper from '../../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../../components/media/MediaSelectorModal";
import { InputGroup } from "../../../components/uiElements/inputGroup";
import { LinkButton } from "../../../components/buttons/buttons";
import { MediaFileCard } from "../../../components/media/MediaFileCard";

// Import utils
import {
    arraysEquals,
    changeStateField, disabledEndDate,
    getInputValues, getPatchReqData, getPostReqData,
    getTranslatableInputValues, getTranslationData, getTranslationsInitialValues,
    initTranslations,
} from "../../../utils/helperFunctions";
import { mapStateToProps } from "../../../redux/mapStateToProps";
import {
    CreatePartner,
    GetPartnerById,
    UpdatePartnerById,
} from "../../../redux/actions";
import { validateTranslations } from "../../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../../constants/acceptedTypes";
import { LanguageTabs } from "../../../components/uiElements/Tabs";
import { MAIN_LANGUAGE_TYPES } from "../../../constants/constsTypes";
import { transformImage } from "../../../utils/transformImage";
import swal from "sweetalert";

class AddEditPartner extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'address',
            'description',

        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields),
                image: null,
                logo: null,
                slug: '',
                categories: [],
                offers: [],

                link: '',
                facebook: '',
                instagram: '',
                linkedin: '',
                tiktok: '',
                youtube: '',
                mail: '',
                phone_number_1: '',
                phone_number_2: '',
                is_hidden: false,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: MAIN_LANGUAGE_TYPES.en,
            requestLoading: false,
            mediaModalType: '',
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslatableInputValues = getTranslatableInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
        this.addEditPartner = this.addEditPartner.bind(this);
    }

    async componentDidMount () {
        const { isEditing } = this.state;

        if (isEditing) {
            await this.props.GetPartnerById(this.props.id);
            const editingData = this.props.partnerById
            if (editingData) {
                const initStateData = {
                    translations: getTranslationsInitialValues(editingData.translations, ['title', 'address', 'description']),
                    image: editingData?.image_object_name ?
                        transformImage(editingData.image_object_name, editingData.image_url)
                        : null,
                    logo: editingData?.logo_object_name ?
                        transformImage(editingData.logo_object_name, editingData.logo_url)
                        : null,
                    slug: editingData?.slug || "",
                    categories: editingData?.categories?.map(c=>c.id) || [],
                    offers: editingData?.offers?.map(o=>o.id)  || [],

                    link: editingData?.link || "",
                    facebook: editingData?.facebook || "",
                    instagram: editingData?.instagram || "",
                    linkedin: editingData?.linkedin || "",
                    tiktok: editingData?.tiktok || "",
                    youtube: editingData?.youtube || "",
                    mail: editingData?.mail || "",
                    phone_number_1: editingData?.phone_number_1 || "",
                    phone_number_2: editingData?.phone_number_2 || "",
                    is_hidden: editingData?.is_hidden,
                }
                this.currentData = JSON.parse(JSON.stringify(initStateData));
                this.setState({
                    fieldsData: initStateData,
                });
            }
        }
    }

    getMedia (type, mediaArray) {
        const { fieldsData, errors } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: mediaArray[0],
            },
            errors: {
                ...errors,
                [type]: false
            }
        })
    }

    deleteMedia (type) {
        const { fieldsData, } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null,
            }
        })
    }

    toggleMediaModalType (type = '') {
        this.setState({
            mediaModalType: type
        })
    }

    treeData = (data) => {
        const treeData = [];
        data.forEach(item => {
            const treeItem = {
                title: item.title || item.name,
                key: item.id,
            };
            treeData.push(treeItem);
        })
        return treeData;
    };

    getMultiSelectData = (checkedKeys, name) => {
        const { fieldsData, isEditing } = this.state;
        if (isEditing) {
            const updatedValues = checkedKeys?.length ? checkedKeys : []
            arraysEquals(this.currentData?.[name], checkedKeys)
                ? this.updatedDataMap.delete(name)
                : this.updatedDataMap.set(name, updatedValues);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [name]: checkedKeys,
            }
        })
    };

    async addEditPartner () {
        // await this.setState({
        //     requestLoading: true
        // });
        const { translations, image, logo, slug, offers } = this.state.fieldsData;
        const translationRequiredFields = ['title', 'address', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!image) {
            errors.image = true;
            result = false;
        }

        if (!slug) {
            errors.slug = true;
            result = false;
        }

        if (!offers?.length) {
            errors.offers = true;
            result = false;
        }

        if (result) {
            if (!this.state.isEditing) {
                let reqData = this.getPostReqData(this.state.fieldsData);
                this.props.CreatePartner(reqData).catch((error) => {
                    if (error && error.response && error.response.status === 409) {
                        swal({
                            title: "Չհաջողվեց!",
                            text: "Slug -ը զբաղված է",
                            icon: "error",
                            button: "Լավ",
                        })
                    }
                }).finally(() => {
                    this.setState({ requestLoading: false });
                })
            } else {
                const reqData = {
                    ...this.getPostReqData(this.state.fieldsData),
                    ...this.getPatchReqData()
                };
                reqData.image_object_name = image?.key;
                reqData.logo_object_name = logo?.key || null;

                // console.log('reqData', reqData)
                    this.props.UpdatePartnerById(this.props.id, reqData).catch((error) => {
                        if (error && error.response && error.response.status === 409) {
                            swal({
                                title: "Չհաջողվեց!",
                                text: "Slug -ը զբաղված է",
                                icon: "error",
                                button: "Լավ",
                            })
                        }
                    })
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }


    render () {

        const { partnerCategoriesList, partnerOffersList } = this.props;
        const {
            fieldsData,
            errors,
            languageTab,
            isEditing,
            errorsTabs,
            requestLoading,
            mediaModalType
        } = this.state;
        const initData = this.currentData?.translations?.find(item => item?.lang === languageTab) || {};
        const currentData = fieldsData.translations?.find(item => item?.lang === languageTab) || {};
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Գործընկեր' : 'Փոփոխել Գործընկերոջը'}>
            <section className="general-add-edit partners-list">
                {isEditing && <div className="fixed-top-right">
                    <label>{!fieldsData.is_hidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.is_hidden}
                            onChange={(checked) => this.getInputValues({
                                name: "is_hidden",
                                value: !checked,
                                haveChanges: this.currentData?.is_hidden !== !checked
                            })}/>
                </div>}
                <div className="top-side">
                    <label>Image <span className={'required-badge'}>*</span></label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn ${errors.image ? 'media-select-error' : ''}`}
                                cb={this.toggleMediaModalType.bind(this, 'image')}
                    />
                </div>
                {fieldsData?.image && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.image}
                    />
                </div>}
                <div className="top-side">
                    <label>Logo image</label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn`}
                                cb={this.toggleMediaModalType.bind(this, 'logo')}
                    />
                </div>
                {fieldsData?.logo && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.logo}
                                   customDelete={this.deleteMedia.bind(this, 'logo')}
                    />
                </div>}


                <div className={'info-block'}>
                    <InputGroup inputType="input"
                                type="text"
                                label="Slug"
                                placeholder="Slug"
                                name="slug"
                                required={true}
                                value={fieldsData?.slug}
                                initValue={this.currentData?.slug}
                                error={errors['slug']}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="URL"
                                placeholder="url"
                                name="link"
                                value={fieldsData.link}
                                initValue={fieldsData.link}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Facebook"
                                placeholder="facebook"
                                name="facebook"
                                value={fieldsData.facebook}
                                initValue={fieldsData.facebook}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Instagram"
                                placeholder="instagram"
                                name="instagram"
                                value={fieldsData.instagram}
                                initValue={fieldsData.instagram}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Linkedin"
                                placeholder="linkedin"
                                name="linkedin"
                                value={fieldsData.linkedin}
                                initValue={fieldsData.linkedin}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Tiktok"
                                placeholder="tiktok"
                                name="tiktok"
                                value={fieldsData.tiktok}
                                initValue={fieldsData.tiktok}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Youtube"
                                placeholder="youtube"
                                name="youtube"
                                value={fieldsData.youtube}
                                initValue={fieldsData.youtube}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="mail"
                                placeholder="mail"
                                name="mail"
                                value={fieldsData.mail}
                                initValue={fieldsData.mail}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Phone number 1"
                                placeholder="Phone number 1"
                                name="phone_number_1"
                                value={fieldsData.phone_number_1}
                                initValue={fieldsData.phone_number_1}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Phone number 2"
                                placeholder="Phone number 2"
                                name="phone_number_2"
                                value={fieldsData.phone_number_2}
                                initValue={fieldsData.phone_number_2}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                </div>

                <div className={'tree-wrapper'}>
                    <div className="tree-item">
                        <label className={`${errors.offers ? 'workout-err' : ''}`}>Առաջարկներ
                            <span className={'required-badge'}>*</span>
                        </label>
                        <Tree
                            checkable
                            checkedKeys={fieldsData.offers}
                            onCheck={(keys) => this.getMultiSelectData(keys, 'offers')}
                            showLine={true}
                            treeData={this.treeData(partnerOffersList)}
                        />
                    </div>
                    <div className="tree-item">
                        <label className={`${errors.categories ? 'workout-err' : ''}`}>Կատեգորիաներ</label>
                        <Tree
                            checkable
                            checkedKeys={fieldsData.categories}
                            onCheck={(keys) => this.getMultiSelectData(keys, 'categories')}
                            showLine={true}
                            treeData={this.treeData(partnerCategoriesList)}
                        />
                    </div>

                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            required={true}
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            onChange={this.getTranslatableInputValues}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Հասցե"
                            placeholder="Հասցե"
                            name="address"
                            required={true}
                            value={currentData.address}
                            initValue={initData.address}
                            error={errors['title' + languageTab]}
                            maxLength={1000}
                            onChange={this.getTranslatableInputValues}/>
                <InputGroup inputType="textarea"
                            type="text"
                            label="Նկարագրություն"
                            placeholder="Նկարագրություն"
                            name="description"
                            required={true}
                            value={currentData.description}
                            initValue={initData.description}
                            error={errors['title' + languageTab]}
                            maxLength={1000}
                            onChange={this.getTranslatableInputValues}/>


                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                cb={this.addEditPartner}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia.bind(this, mediaModalType)}
                closeModal={this.toggleMediaModalType.bind(this)}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreatePartner,
    GetPartnerById,
    UpdatePartnerById,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditPartner)
